'use strict'

// Site-wide cookie consent (Consent Mode v2 bridge). Shared by autoin.no and autofrakt.no.
// See .local/specs/spec-autoin-tier1-tier2-implementation.md §1.

const COOKIE_NAME = 'site_consent';
const STORAGE_KEY = 'site_consent';
const COOKIE_MAX_AGE_DAYS = 365;

function readCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name, value) {
    const days = COOKIE_MAX_AGE_DAYS;
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; expires=' + expires + '; SameSite=Lax' + secure;
}

function readState() {
    // Prefer localStorage (faster for client-side reads), fall back to cookie.
    let raw = null;
    try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (!raw) raw = readCookie(COOKIE_NAME);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') return parsed;
    } catch (e) {}
    return null;
}

function persistState(state) {
    const json = JSON.stringify(state);
    try { localStorage.setItem(STORAGE_KEY, json); } catch (e) {}
    writeCookie(COOKIE_NAME, json);
}

function pushConsentUpdate(state) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
        'analytics_storage': state.analytics ? 'granted' : 'denied',
        'ad_storage': state.marketing ? 'granted' : 'denied',
        'ad_user_data': state.marketing ? 'granted' : 'denied',
        'ad_personalization': state.marketing ? 'granted' : 'denied'
    });
}

function updateBubbleRing(state) {
    const bubble = document.getElementById('cookie-bubble');
    if (!bubble) return;
    bubble.classList.remove('border-warning', 'border-success', 'border-secondary');
    if (state === null) {
        bubble.classList.add('border-warning');
    } else if (state.analytics || state.marketing) {
        bubble.classList.add('border-success');
    } else {
        bubble.classList.add('border-secondary');
    }
}

function showBanner() {
    const banner = document.getElementById('cookie-consent-banner');
    if (!banner) return;
    banner.classList.remove('d-none');
    banner.setAttribute('aria-hidden', 'false');
    // Move focus to the recommended button for accessibility
    const recommended = banner.querySelector('[data-ai-consent="selected"]');
    if (recommended) recommended.focus({ preventScroll: true });
}

function hideBanner() {
    const banner = document.getElementById('cookie-consent-banner');
    if (!banner) return;
    banner.classList.add('d-none');
    banner.setAttribute('aria-hidden', 'true');
}

function applyChoice(analytics, marketing) {
    const state = { v: 1, ts: Math.floor(Date.now() / 1000), analytics: !!analytics, marketing: !!marketing };
    persistState(state);
    pushConsentUpdate(state);
    updateBubbleRing(state);
    hideBanner();
}

const SiteConsent = {
    open: showBanner,
    close: () => { if (readState() !== null) hideBanner(); },
    set(category, granted) {
        const cur = readState() || { v: 1, ts: Math.floor(Date.now() / 1000), analytics: false, marketing: false };
        cur[category] = !!granted;
        cur.ts = Math.floor(Date.now() / 1000);
        persistState(cur);
        pushConsentUpdate(cur);
        updateBubbleRing(cur);
    },
    get(category) {
        const s = readState();
        return s ? !!s[category] : false;
    },
    acceptAll: () => applyChoice(true, true),
    acceptSelected: () => applyChoice(true, false),
    rejectAll: () => applyChoice(false, false)
};

window.SiteConsent = SiteConsent;

function init() {
    const state = readState();
    updateBubbleRing(state);

    if (state === null) {
        // No prior choice — show banner
        showBanner();
    }

    // Banner button wiring
    const banner = document.getElementById('cookie-consent-banner');
    if (banner) {
        banner.addEventListener('click', (e) => {
            const target = e.target.closest('[data-ai-consent]');
            if (!target) return;
            e.preventDefault();
            const action = target.getAttribute('data-ai-consent');
            if (action === 'all') SiteConsent.acceptAll();
            else if (action === 'selected') SiteConsent.acceptSelected();
            else if (action === 'necessary') SiteConsent.rejectAll();
        });
    }

    // Re-consent bubble — switch from anchor to opener.
    const bubble = document.getElementById('cookie-bubble');
    if (bubble) {
        bubble.addEventListener('click', (e) => {
            // If the bubble has been turned into a re-consent trigger via data attr, intercept
            if (bubble.hasAttribute('data-ai-consent-toggle')) {
                e.preventDefault();
                showBanner();
            }
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
    init();
}

export { SiteConsent };
